import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {
  
  public service;    
  constructor() { }
  ngOnInit() {
    let scripts = new ScriptsModule;
    scripts.loadScript('assets/js/scripts/services.js');
  }   
    
    showService(n){


        this.service=n;
        $('#modalServicios').modal('show'); 
    }
}



// WEBPACK FOOTER //
// ./src/app/components/services/services.component.ts